export default [
    {
        path: 'relatorio-de-aplicacao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-relatorio-de-aplicacao' */ '@/views/imunizacao/relatorio-de-aplicacao/Index'),
        redirect: 'relatorio-de-aplicacao/index',
        children: [
            {
                name: 'imunizacao-relatorio-de-aplicacao-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-relatorio-de-aplicacao' */ '@/views/imunizacao/relatorio-de-aplicacao/List.vue'),
            },
        ],
    },
]